var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroIconImage3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    transform: "matrix(0.939693 -0.34202 0.340242 0.940338 0.00927734 10.981)",
    fill: "#054F48"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_130_5590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2041 26.6986C19.8393 27.9232 16.124 26.1864 14.9057 22.8194C13.6873 19.4522 15.4274 15.7299 18.7922 14.5052C22.157 13.2805 25.8724 15.0173 27.0907 18.3844C28.309 21.7515 26.5689 25.4739 23.2041 26.6986ZM22.7629 25.4792C25.4548 24.4995 26.8468 21.5216 25.8722 18.8279C24.8975 16.1342 21.9253 14.7447 19.2334 15.7245C16.5416 16.7043 15.1495 19.6822 16.1242 22.3759C17.0988 25.0696 20.0711 26.459 22.7629 25.4792ZM21.6074 20.3801L24.0444 19.4931L24.4856 20.7125L20.8301 22.0429L19.2859 17.7753L20.5044 17.3318L21.6074 20.3801Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_130_5590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5604,
    height: 15.5604,
    fill: "white",
    transform: "matrix(0.939692 -0.34202 0.340242 0.940338 11.0405 15.9468)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroIconImage3);
export default __webpack_public_path__ + "static/media/hero-icon-image-3.9e46ea54b3c96b5ca8428b8b3c372ea5.svg";
export { ForwardRef as ReactComponent };